import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_DOWNLOAD_BILL_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetBillPDFRequestPayload, GetBillPDFResponseResult } from '../types/getBillPdf.types';

export const getBillPdf = (builder: BuilderType) =>
  builder.query<GetBillPDFResponseResult, GetBillPDFRequestPayload>({
    providesTags: ['OutstandingBill'],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_DOWNLOAD_BILL_URL,
    }),

    transformResponse: (response: GenericApiResponse<GetBillPDFResponseResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
